import { useNavigate } from 'react-router';
import { toast } from 'sonner';

import { ForgotPasswordForm } from '@/forms/ForgotPasswordForm/ForgotPasswordForm';
import { AuthLayout } from '@/layouts/AuthLayout';
import { useAuth } from '@/lib/auth';
import { useTranslation } from 'react-i18next';

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  useAuth({
    middleware: 'guest',
    tmp: 'ForgotPassword',
  });

  const navigate = useNavigate();

  return (
    <AuthLayout>
      <title>{t('forgotPassword.title')}</title>

      <ForgotPasswordForm
        action="/auth/forgot-password"
        onSuccess={(response) => {
          if (response.status === 200 || response.status === 204) {
            toast.success(t('forgotPassword.success.title'), {
              description: t('forgotPassword.success.description'),
              duration: 5000,
              onDismiss: () => {
                navigate('/auth/reset-password');
              },
            });
            return;
          }

          toast.error(t('forgotPassword.pageError.title'), {
            description: t('forgotPassword.pageError.description'),
            duration: 5000,
            onDismiss: () => {
              window.location.reload();
            },
          });
        }}
      />
    </AuthLayout>
  );
}
